import { RootState } from 'src/state/rootReducer';

export const getUsersData = (state: RootState) => {
  return state.entities.users;
};
